(function () {

    let row = null;

    document.addEventListener('DOMContentLoaded', async function () {
        const keyElement = document.querySelector("[data-key]");
        const key = keyElement ? keyElement.dataset.key : undefined;
        const root = document.getElementById('bookmarks-root');
        const loadingElement = document.getElementById('bookmarks-loading');
        if (!root || !uuid) return;

        let currentPage = 1;
        let isLoading = false;
        let hasMorePosts = true;
        const postsPerPage = 8;
        let allBookmarkedPosts = [];

        async function loadBookmarks(page) {
            if (isLoading || !hasMorePosts) return;

            isLoading = true;
            loadingElement.style.display = 'block';
            let bookmarks = [];

            try {
                // First, get all bookmarked post IDs if we haven't already
                if (allBookmarkedPosts.length === 0) {
                    const bookmarksRes = await fetch(getBookmarsListUrl+'?user_id='+uuid);
                    bookmarks = await bookmarksRes.json();
                    allBookmarkedPosts = Array.isArray(bookmarks) ? bookmarks : [];
                }

                if (allBookmarkedPosts.length === 0) {
                    root.style.marginTop  = '20px';
                    root.textContent = 'No bookmarks found.';
                    return;
                }

                // Calculate the start and end indices for the current page
                const startIndex = (page - 1) * postsPerPage;
                const endIndex = startIndex + postsPerPage;
                const currentPagePostIds = allBookmarkedPosts.slice(startIndex, endIndex);

                if (currentPagePostIds.length === 0) {
                    hasMorePosts = false;
                    return;
                }

                // Fetch the posts for the current page
                const postsRes = await fetch('/ghost/api/content/posts/?key='+key+'&filter=id:['+currentPagePostIds.join(',')+']&include=tags');
                const { posts } = await postsRes.json();
                const windowWidth = window.innerWidth;
                const numberOfChildren = windowWidth < 768 ? 2 : 4;
                if (posts && posts.length > 0) {
                    posts.forEach(function (post, index) {
                        if (row && row.children.length === numberOfChildren) {
                            root.appendChild(row);
                            row = null;
                        }
                        if (!row) {
                            row = document.createElement('div');
                            row.classList.add('bookmarks-flex');
                        }
                        const card = document.createElement('article');
                        card.className = 'post-card post';
                        // Feature image
                        if (post.feature_image) {
                            const imgLink = document.createElement('a');
                            imgLink.className = 'post-card-image-link';
                            imgLink.href = post.url;
                            const img = document.createElement('img');
                            img.className = 'post-card-image';
                            img.src = post.feature_image;
                            img.alt = post.feature_image_alt || post.title;
                            img.loading = 'lazy';
                            imgLink.appendChild(img);
                            card.appendChild(imgLink);
                        }

                        // Content
                        const contentDiv = document.createElement('div');
                        contentDiv.className = 'post-card-content';

                        // Content link
                        const contentLink = document.createElement('a');
                        contentLink.className = 'post-card-content-link';
                        contentLink.href = post.url;

                        // Header
                        const header = document.createElement('header');
                        header.className = 'post-card-header';

                        // Header row
                        const headerRow = document.createElement('div');
                        headerRow.className = 'post-card-header-row';

                        // Time
                        const time = document.createElement('time');
                        time.className = 'post-card-meta-date';
                        time.setAttribute('datetime', post.published_at ? post.published_at.split('T')[0] : '');
                        time.innerText = post.published_at ? new Date(post.published_at).toLocaleDateString() : '';
                        headerRow.appendChild(time);

                        // Bookmark button
                        const button = document.createElement('button');
                        button.type = 'button';
                        button.setAttribute('data-id', post.id);
                        button.className = 'bookmark';
                        button.tabIndex = 0;
                        button.setAttribute('aria-label', 'Add bookmark');
                        button.setAttribute('data-bookmarked', 'false');
                        // SVGs
                        button.innerHTML = '<svg viewBox="0 0 32 32" class="add-bookmark-icon" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                '<circle cx="16" cy="16.0001" r="13.2857" stroke="#454545" stroke-width="2"></circle>'+
                                '<path d="M11.4286 22.2861V11.7074C11.4286 11.3567 11.546 11.0639 11.781 10.8289C12.0159 10.594 12.3087 10.4766 12.6594 10.4766H17.348C17.1526 10.7794 17.006 11.0834 16.9084 11.3886C16.8107 11.6938 16.7619 12.0248 16.7619 12.3813C16.7619 13.2663 17.0557 14.0311 17.6433 14.6758C18.2308 15.3205 18.9529 15.6878 19.8095 15.7777C19.9551 15.7962 20.082 15.8055 20.1905 15.8055C20.2989 15.8055 20.4259 15.7962 20.5714 15.7777V22.2861L16 20.3227L11.4286 22.2861ZM19.8095 14.2861V12.7623H18.2857V12.0004H19.8095V10.4766H20.5714V12.0004H22.0953V12.7623H20.5714V14.2861H19.8095Z" fill="#FAFAEA"></path>'+
                            '</svg>'+
                            '<svg class="remove-bookmark-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                '<path d="M16.0005 2.71429C23.3378 2.71452 29.2856 8.66307 29.2856 16.0004C29.2854 23.3376 23.3377 29.2854 16.0005 29.2856C8.66313 29.2856 2.71458 23.3377 2.71436 16.0004C2.71436 8.66293 8.66299 2.71429 16.0005 2.71429Z" stroke="#454545" stroke-width="2"></path>'+
                                '<path d="M22.0949 12.3333H18.2854V11.5714H22.0949V12.3333ZM11.4282 21.8571V11.2785C11.4282 10.9277 11.5457 10.6349 11.7806 10.4C12.0155 10.1651 12.3083 10.0476 12.6591 10.0476H17.3477C17.1522 10.3505 17.0057 10.6545 16.908 10.9596C16.8104 11.2649 16.7616 11.5958 16.7616 11.9524C16.7616 12.8373 17.0553 13.6021 17.6429 14.2468C18.2304 14.8915 18.9525 15.2588 19.8092 15.3488C19.9547 15.3673 20.0817 15.3766 20.1901 15.3766C20.2986 15.3766 20.4256 15.3673 20.5711 15.3488V21.8571L15.9997 19.8937L11.4282 21.8571Z" fill="#AE2523"></path>'+
                            '</svg>';
                        headerRow.appendChild(button);

                        // Title
                        const h2 = document.createElement('h2');
                        h2.className = 'post-card-title';
                        h2.innerText = post.title;
                        header.appendChild(headerRow);
                        header.appendChild(h2);
                        contentLink.appendChild(header);

                        // Footer
                        const footer = document.createElement('footer');
                        footer.className = 'post-card-meta';
                        // Tags
                        const tagsDiv = document.createElement('div');
                        tagsDiv.className = 'post-card-tags';
                        if (post.primary_tag) {
                            const tagSpan = document.createElement('span');
                            tagSpan.className = 'post-card-primary-tag';
                            const tagLink = document.createElement('a');
                            tagLink.className = 'icon-x icon-' + post.primary_tag.slug;
                            tagLink.href = post.primary_tag.url;
                            tagLink.innerText = post.primary_tag.name;
                            tagSpan.appendChild(tagLink);
                            tagsDiv.appendChild(tagSpan);
                        }
                        if (post.featured) {
                            const featuredSpan = document.createElement('span');
                            featuredSpan.className = 'post-card-featured';
                            featuredSpan.innerText = 'Featured';
                            tagsDiv.appendChild(featuredSpan);
                        }
                        footer.appendChild(tagsDiv);
                        contentLink.appendChild(footer);
                        contentDiv.appendChild(contentLink);
                        card.appendChild(contentDiv);
                        row.appendChild(card);
                    });
                    if (row.children.length > 0) {
                        root.appendChild(row);
                        row = null;
                    }
                    hasMorePosts = endIndex < allBookmarkedPosts.length;
                    currentPage = page;
                } else if (page === 1) {
                    root.textContent = 'No bookmarks found.';
                }
                return bookmarks;
            } catch (err) {
                console.error('Failed to load bookmarks:', err);
                if (page === 1) {
                    root.textContent = 'Failed to load bookmarks.';
                }
            } finally {
                isLoading = false;
                loadingElement.style.display = 'none';
            }

            return [];


        }

        // Initial load
        const bookmarks = await loadBookmarks(1);
        captureBookmarkButtons(bookmarks)

        // Infinite scroll
        let ticking = false;
        const buffer = 300;

        async function onScroll() {
            if (ticking) return;
            ticking = true;

            const scrollY = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            if (scrollY + windowHeight >= documentHeight - buffer) {
                await loadBookmarks(currentPage + 1);
                captureBookmarkButtons(bookmarks)
            }

            ticking = false;
        }

        window.addEventListener('scroll', onScroll);
    });
})(window, document);
